document.addEventListener("DOMContentLoaded", () => {

  const reveals = document.querySelectorAll('.tx-reveal');

  const observer = new IntersectionObserver((entries)=>{

    entries.forEach((entry)=>{

      if(entry.isIntersecting){
        entry.target.classList.add('active');
      }

    });

  });

  reveals.forEach((item)=>{
    observer.observe(item);
  });

});